import { useState, useEffect } from 'react';
import { FetchEventData } from '../Utils/FetchImageEventData';

export const useLastMonthEvents = () => {
  const [lastEventsData, setLastEventsData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadEvents = async () => {
      try {
        setLoading(true);
        const data = await FetchEventData("August");
        setLastEventsData(data);
        setError(null);
      } catch (err) {
        console.error("Error loading last month events:", err);
        setError(err);
        setLastEventsData(null);
      } finally {
        setLoading(false);
      }
    };
    loadEvents();
  }, []);

  return { 
    lastEventsData, 
    loading, 
    error,
    lastEvents: lastEventsData?.events || []
  };
};
